<template>
    <div>
        <b-modal ref="addBasketModal" id="addBasketModal" centered hide-footer hide-header>

            <div class="close" @click="$bvModal.hide('addBasketModal')"><img src="/svg/close.svg" alt=""></div>

            <div class="d-block text-center">
                <h2 class="color-primary mb-32">Товар добавлен в корзину</h2>


                <div v-if="store.state.basket_accessories && store.state.basket_accessories.length > 0" class="mb-32">
                    <hr>
                    <div class="title-4 mb-24 text-left">Рекомендуемые аксессуары к данному товару:</div>
                    <div class="catalog-container">
                        <carousel
                            :responsive="{0:{margin:2, items:1.5, mouseDrag:true, touchDrag:true, nav:(store.state.basket_accessories.length > 1) ? true:false},
                            400:{items:2, mouseDrag:true, touchDrag:true, nav:(store.state.basket_accessories.length > 2) ? true : false},
                            535:{items:3, mouseDrag:true, touchDrag:true, nav:(store.state.basket_accessories.length > 3) ? true : false},
                            991:{items:4,mouseDrag:true, touchDrag:true, nav:(store.state.basket_accessories.length > 4) ? true : false},
                            1200:{items:5,mouseDrag:(store.state.basket_accessories.length > 5) ? true : false,
                            touchDrag:(store.state.basket_accessories.length > 5) ? true : false,
                            nav:(store.state.basket_accessories.length > 5) ? true : false}}"
                            :margin="7" :dots="false"
                            :loop="(store.state.basket_accessories.length > 5) ? true : false">

                            <catalog-card v-for="(item, i) in store.state.basket_accessories" :key="i"
                                          :item="item" :additional="true"></catalog-card>
                        </carousel>
                    </div>
                    <hr>
                </div>

                <div
                    v-if="!store.state.basket_accessories || store.state.basket_accessories && store.state.basket_accessories.length < 1">
                    <div class="title-4 mb-32">
                        <div class="font-700">{{store.state.basket_name}}</div> успешно скопирован и добавлен в
                        корзину. <br>
                        Вы можете перейти в корзину и приступить к оформлению заказа либо продолжить выбор товаров.
                    </div>
                </div>

                <div class="d-sm-flex justify-content-center">
                    <router-link to="/basket" @click="$bvModal.hide('addBasketModal')"
                                 class="button btn-large btn-v2 mr-sm-1 mr-md-2 mr-0 ml-md-2 ml-1 mb-3 mb-sm-0">Перейти в корзину
                    </router-link>
                    <button class="button btn-large ml-md-2 ml-1"
                            @click="$bvModal.hide('addBasketModal')">Закрыть
                    </button>
                </div>


            </div>
        </b-modal>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel';
    import store from '../../services/data'

    export default {
        components: {carousel},

        data() {
            return {
                store: store
            }
        },

        watch: {
            $route() {
                this.$bvModal.hide('addBasketModal')
            }
        },


    }
</script>
